import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

import NavBar from "../common/components/NavBar";
import { routes } from "../../Router";
import { getLeadSearches } from "../../api/LeadSearch";
import LoadingIndicator from "../common/components/LoadingIndicator";
import LeadSearchList from "./LeadSearchList";

export default function Home(): React.JSX.Element {
  /**
   * Home screen.
   */
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  const [leadSearches, setLeadSearches] = React.useState<ILeadSearch[]>([]);

  React.useEffect(() => {
    getLeadSearches().then((_leadSearches: ILeadSearch[]) => {
      setLeadSearches(_leadSearches);
      setIsLoading(false);
    });
  }, []);

  const handleLeadSearchCreate = () => {
    navigate(routes.leadSearchCreate);
  };

  const handleLeadSearchDelete = (leadSearchId: string) => {
    setLeadSearches(
      leadSearches.filter((_leadSearch) => _leadSearch.id !== leadSearchId),
    );
  };

  return (
    <div className="w-100">
      <Container fluid={true} className="w-100 min-h-100vh d-flex flex-column">
        <NavBar bgTransparent={true} />
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          <div className="d-flex flex-column flex-grow-1 justify-content-between align-items-center mt-3">
            <Row className="d-flex flex-row flex-grow-1 w-100">
              <Col className="d-flex flex-column align-items-center justify-content-center my-3">
                <div className="d-flex flex-column">
                  <Button
                    title="Nieuwe zoekopdracht"
                    variant="primary"
                    className="text-center px-4"
                    onClick={handleLeadSearchCreate}
                  >
                    <div className="d-inline-flex align-items-center">
                      <Search className="me-3" />
                      Nieuwe zoekopdracht
                    </div>
                  </Button>

                  <Button
                    title="Uitloggen"
                    variant="outline-danger"
                    className="text-center px-4 mt-3"
                    onClick={() => navigate(routes.logout)}
                  >
                    Uitloggen
                  </Button>
                </div>
              </Col>

              {leadSearches.length > 0 && (
                <Col className="d-flex flex-column align-items-start">
                  <Form.Label>
                    <h5 className="mb-0">Vorige zoekopdrachten</h5>
                  </Form.Label>
                  <div className="flex-grow-1 h-100vh-minus-nav-and-header overflow-y-auto w-100">
                    <LeadSearchList
                      leadSearches={leadSearches}
                      onLeadSearchDelete={handleLeadSearchDelete}
                    />
                  </div>
                </Col>
              )}
            </Row>
          </div>
        )}
      </Container>
    </div>
  );
}
